import { getCompanyName, Locale, LOCALE_LINKS, useLocale } from '../../helpers/LangHelper';
import styles from './sign-up-card.module.scss';

interface Props {}

const SignUpCard = (props: Props) => {
    const { locale } = useLocale();

    return (
        <a href={(LOCALE_LINKS[locale] || LOCALE_LINKS[Locale.USA])!.signup} rel="noreferrer" target="_blank">
            <div className={styles.signUpCard}>
                {/* <div className={styles.backgroundImage}>
                    <ImageBackgroundSignUpCard />
                </div> */}
                <div className={styles.backgroundImagePNG}>
                    <img src="https://cdn.builder.io/api/v1/image/assets%2F035a3d41874344d79b6c7499e2e7a5bc%2Fae580468d8b54acfa8730259d44f334a" alt="" />
                </div>
                <div className={styles.infoDetail}>
                    <p className={styles.title}>Sign up to {getCompanyName(locale)} Now!</p>
                    <p className={styles.description}>Get {getCompanyName(locale)} for your business.</p>
                </div>
                <div className={styles.buttonSubscribe}>
                    <span>Sign up</span>
                    {/* <Icon type={IconType.ArrowRightMedium} /> */}
                </div>
            </div>
        </a>
    );
};

export default SignUpCard;
